<main class="container-learning-zone">
  <h2 class="title-learning-zone">Hola {{infoUser.attributes.field_name}}, ¿Listo para aprender algo nuevo?</h2>
  <section class="bottom-section-learning-route">
    <article class="pends-learning-zone">
      <article class="wrapper-pend-top">
        <div class="pend-title">
          <span>PENDIENTES</span>
          <span class="pend-icon" *ngIf="!content.hasPends">{{filteredActivities.length}}</span>
        </div>
        <div class="dropdown-center">
          <button class="btn-filter-pend" data-bs-toggle="dropdown" [class.opacity]="content.hasPends" [disabled]="content.hasPends">
            <img
              src="../../../assets/icons/filter-tribe-icon.svg"
              alt="filter icon"
            />
            {{option}}
            <img
              src="../../../assets/icons/arrow-filter-tribe-icon.svg"
              alt="arrow filter icon"
            />
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" (click)="onClick('Esta semana')">Esta semana</a></li>
            <li><a class="dropdown-item" (click)="onClick('Próxima semana')">Próxima semana</a></li>
            <li><a class="dropdown-item" (click)="onClick('Todos los pendientes')">Todos los pendientes</a></li>
          </ul>
        </div>
      </article>
      <section class="pending-act-box" [class.display-none]="content.hasPends">
        <article *ngFor="let act of filteredActivities; let i = index">
          <section class="card-activity">
              <time class="time-activity-in-card">{{ act.attributes.field_date_range.end_value | fechaEs:'daysLeft' }}</time>
              <time class="date-activity-in-card">{{act.attributes.field_date_range.end_value | fechaEs: 'date'}}</time>
              <span class="date-activity-in-card">Curso: {{act.courseTitle}}</span>
              <span class="title-activity-in-card">{{act.attributes.title}}</span>
              <button class="btn-activity-in-card" [routerLink]="['/cursos' + act.coursePath + act.lessonPath + act.attributes.path.alias]" [disabled]="!content.isLinkArrived" [class.opacity]="!content.isLinkArrived">Enviar actividad</button>
          </section>
        </article>

      </section>
      <!-- <article  class="msg2-not-pends" *ngIf="content.hasPends || filteredActivities?.length === 0"> -->
      <article  class="msg2-not-pends" *ngIf="content.hasPends">
        <span>No tienes pendientes por el momento</span>
        <span>¡Continúa aprendiendo!</span>
      </article>
    </article>
    <article class="pends-learning-zone">
      <article class="wrapper-pend-top">
        <div class="pend-title">
          <span>INSIGNIAS</span>
        </div>
      </article>
      <section class="pending-act-box">
        <article class="sect-insignia">
          <div class="insignia" *ngFor="let course of coursesWithInsignia">
            <img src="../../../assets/icons/back-insignia.svg" alt="" class="img-insignia" />
            <img src="../../../assets/icons/Ellipse 15.svg" alt="" class="ellipse" />
            <img [src]="course.insignia?.url" alt="" class="text-insignia" *ngIf="course.certificate" appTooltip data-bs-toggle="tooltip" data-bs-placement="top"
            data-bs-custom-class="custom-tooltip"
            [attr.data-bs-title]="course.relationships.field_insignia.data?.meta?.title"/>
          </div>
          <div type="button" class="insignia" *ngFor="let insignia of insigniasService.insignias" appTooltip data-bs-toggle="tooltip" data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          [attr.data-bs-title]="insignia.name">
            <img src="../../../assets/icons/back-insignia.svg" alt="" class="img-insignia" />
            <img src="../../../assets/icons/Ellipse 15.svg" alt="" class="ellipse" />
            <img [src]="insignia.image" alt="insignia.name" class="text-insignia"/>
          </div>
        </article>
      </section>
      <article  class="msg2-not-pends" *ngIf="!hasCourses">
        <span>Completa tus cursos para obtener insignias</span>
        <span>¡Continúa aprendiendo!</span>
      </article>
    </article>
  </section>
  <section class="certificates">
    <article class="wrapper-pend-top">
      <div class="pend-title">
        <span>CERTIFICADOS</span>
      </div>
    </article>
    <section class="items">
      <app-certificates-card></app-certificates-card>
    </section>
  </section>
</main>
